const drawerTheme = {
  drawer: {
    transitionDurationMs: 200,
    overlay: {
      background: 'rgba(14, 14, 14, 0.8)',
    },
    slider: {
      overflow: 'auto',
      padding: 0,
      maxWith: 'unset',
      maxHeight: 'unset',
      background: '#000',
      top: { closed: 'translate(0, -100%)' },
      right: { closed: 'translate(100%, 0)' },
      bottom: { closed: 'translate(0, 100%)' },
      left: { closed: 'translate(-100%, 0)' },
      boxShadow: '0 2px 8px 0 rgba(204, 204, 204, 0.5)',
    },
  },
};

export default drawerTheme;
